import type { ReactNode } from 'react';

interface HeadingProps {
  children: ReactNode;
  level?: 1 | 2 | 3 | 4;
  variant?: 'default' | 'display';
  className?: string;
}

const variantClasses = {
  default: 'font-ui text-ink-strong',
  display: 'font-display text-ink-strong display',
} as const;

const levelClasses = {
  1: 'text-4xl sm:text-5xl',
  2: 'text-2xl sm:text-3xl',
  3: 'text-xl sm:text-2xl',
  4: 'text-lg',
} as const;

export function Heading({ children, level = 1, variant = 'default', className = '' }: HeadingProps) {
  const Tag = `h${level}` as const;
  return (
    <Tag className={`${variantClasses[variant]} ${levelClasses[level]} ${className}`}>
      {children}
    </Tag>
  );
}
